var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReflection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: 808080,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.80521V17.2174C0 18.3652 0.9 19.3043 2 19.3043H16L20 23.4783V4.69564C20 3.54782 19.1 2.60869 18 2.60869H7.9C7.96 2.9426 8 3.29738 8 3.65216C8 4.00695 7.96 4.36173 7.9 4.69564H18V17.2174H2V8.76521C1.26 8.60869 0.58 8.26434 0 7.80521ZM6 3.65216C6 5.38434 4.66 6.7826 3 6.7826C1.34 6.7826 0 5.38434 0 3.65216C0 1.91999 1.34 0.521729 3 0.521729C4.66 0.521729 6 1.91999 6 3.65216Z",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReflection);
export default __webpack_public_path__ + "static/media/reflection.c6f765cd662827ac1564011f0192fc79.svg";
export { ForwardRef as ReactComponent };